import { useEffect, useState } from 'react';
import { Spinner } from '../ui/Spinner';

interface PhaseLoaderProps {
  phases: string[];
  /** ms between phase advances. Default 4 000 */
  interval?: number;
}

export function PhaseLoader({ phases, interval = 4000 }: PhaseLoaderProps) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setPhase(p => Math.min(p + 1, phases.length - 1)), interval);
    return () => clearInterval(t);
  }, [phases.length, interval]);

  return (
    <div style={{ textAlign: 'center', padding: '2.5rem 1rem' }}>
      <Spinner size="lg" />
      <p
        className="animate-fade-in"
        key={phase}
        style={{
          color: 'var(--celeste-soft)',
          marginTop: '1.5rem',
          fontSize: 'var(--text-label)',
          fontStyle: 'italic',
          lineHeight: 1.5,
        }}
      >
        {phases[phase]}
      </p>
      {/* Progress dots */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '0.375rem', marginTop: '1.25rem' }}>
        {phases.map((_, i) => (
          <div
            key={i}
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: i <= phase ? 'var(--petrol)' : 'var(--line-soft)',
              transition: 'background 0.4s ease',
            }}
          />
        ))}
      </div>
    </div>
  );
}
